var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M198.344,41.156C194.672,31.447,185.381,25.017,175,25H25C14.434,25.028,5.026,31.696,1.5,41.656 C0.493,44.322-0.016,47.15,0,50v100c0.008,10.18,6.188,19.339,15.625,23.156c2.974,1.223,6.159,1.85,9.375,1.844h150 c3.057,0.018,6.084-0.578,8.906-1.75c5.513-2.023,10.115-5.961,12.969-11.094c2.059-3.721,3.135-7.904,3.125-12.156V50 C199.997,46.975,199.436,43.977,198.344,41.156z M16.656,50c0.017-4.601,3.743-8.327,8.344-8.344h150 c4.602,0.017,8.326,3.743,8.344,8.344v1.594l-66.438,50l-13.781,10.656L100,114.594l-3.125-2.438L82.938,101.75L16.656,51.906V50z  M16.656,150V72.75l52.438,39.406l-52.25,39.25C16.728,150.945,16.665,150.475,16.656,150z M35.406,158.344L83,122.594l12,9.063 c2.954,2.25,7.047,2.25,10,0l11.906-9l47.25,35.688H35.406V158.344z M183.344,150c0,0.592-0.084,1.182-0.25,1.75l-52.344-39.594 l52.594-39.75V150z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.91d07780f511367935434092500ae5fc.svg";
export { ForwardRef as ReactComponent };